<template>
  <div aria-label="listfilterbutton" class="asc-list-filter-button--container">
    <div :class="['asc-list-filter-button--options-container']">
      <div class="pretty p-icon p-smooth p-has-indeterminate">
        <input
          ref="ascListFilter"
          v-model="model"
          type="checkbox"
          aria-label="List Filter Button"
          :disabled="disableSelectAll"
          @change="handleChange"
        />
        <div class="state p-primary">
          <i class="icon mdi mdi-check-bold accent"></i>
          <label>{{ getLabelText }}</label>
        </div>
        <div class="state p-primary p-is-indeterminate">
          <i class="icon mdi mdi-minus"></i>
          <label>{{ getLabelText }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AscListFilterButton',

  props: {
    value: {
      type: Number,
      default: 0,
    },
    disableSelectAll: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      checked: this.value === 1,
      disabled: false,
      indeterminate: this.value === 2,
      menuItems: [
        { title: 'All', value: 1 },
        { title: 'None', value: 0 },
      ],
      showMenu: false,
      viewModel: this.value === 1,
    }
  },

  computed: {
    model: {
      get() {
        return this.viewModel
      },
      set(newValue) {
        this.checked = newValue === 1 || newValue === true
        this.indeterminate = newValue === 2
        this.updateIndeterminate()
        this.viewModel = newValue === 1 || newValue === true
        this.$emit('input', newValue)
      },
    },
    getLabelText() {
      if (this.checked === true) {
        return 'Unselect All'
      }
      return 'Select All'
    },
  },

  watch: {
    value(newValue) {
      this.model = newValue
    },
  },

  mounted() {
    this.updateIndeterminate()
  },

  methods: {
    handleChange() {
      this.model = this.checked ? 1 : 0
    },
    handleItemClick(item) {
      this.model = item.value === 1 ? 1 : 0
    },
    isIndeterminate() {
      const cb = this.$refs.ascListFilter
      if (cb) {
        return cb.indeterminate === true
      }
      return false
    },
    updateIndeterminate() {
      const cb = this.$refs.ascListFilter
      cb.indeterminate = cb && this.indeterminate
    },
  },
}
</script>

<style lang="scss">
.asc-list-filter-button--container {
  display: flex;
  margin-left: -4px;
  flex: 1;

  & .asc-list-filter-button--options-container {
    margin-left: 8px;
    position: relative;
    width: 30px;
    height: 36px;
    background-color: $primary-white;

    & .pretty {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin-right: 0;
      width: 18px;

      label {
        padding-left: 8px;
      }

      & .p-primary {
        label {
          font-size: 14px;
        }
      }
    }

    .pretty.p-icon .state .icon {
      font-size: 14px;
    }

    & .pretty input {
      &:hover {
        color: $gray-200;
      }
    }

    // stylelint-disable
    & .pretty input:checked ~ .state.p-primary label::after,
    & .pretty.p-toggle .state.p-primary label::after {
      background-color: $gray-500 !important;
    }
    // stylelint-enable

    & .accent {
      border: 1px solid $accent-500 !important;
      background-color: $accent-500 !important;
      color: $primary-black !important;
      stroke: $primary-black !important;
    }
  }
}
</style>
